import { useState } from 'react'
import { putCookie, useQuery } from '@chilecompra/react-kit'
import { format } from 'date-fns'

import { useAuthorization } from '../AuthProvider/AuthProvider.hooks'
import { updateQuery } from '../../modules/utils/searches'
import useConditionalSearchNavigate from '../../modules/hooks/useCondicionalSearchNavigate'

import {
  DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_BUYER,
  DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_PUBLIC,
  DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_SELLER,
  DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES
} from '../../config/settings/constants'

export function useDirectDealSearch({ initialValues }) {
  const { isBuyer, isSeller } = useAuthorization()
  const query = useQuery()
  const { conditionalNavigate } = useConditionalSearchNavigate(isSeller, isBuyer)

  const [searchValues, setSearchValues] = useState(initialValues)

  const handleSearch = updatedValues => {
    let dictionary = {
      ...DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES,
      ...Object.fromEntries(query.entries()),
      orderBy: updatedValues.orderValue,
      page: DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES.page
    }

    if (
      updatedValues.dateFromError === '' &&
      updatedValues.dateFromValue instanceof Date &&
      !isNaN(updatedValues.dateFromValue)
    ) {
      dictionary.dateFrom = format(updatedValues.dateFromValue, 'dd/MM/yyyy')
    }

    if (
      updatedValues.dateToError === '' &&
      updatedValues.dateToValue instanceof Date &&
      !isNaN(updatedValues.dateToValue)
    ) {
      dictionary.dateTo = format(updatedValues.dateToValue, 'dd/MM/yyyy')
    }

    if (isSeller) {
      dictionary = {
        ...dictionary,
        ...DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_SELLER
      }

      dictionary.organization = updatedValues.byOrganizationOption?.value || ''
      dictionary.region = updatedValues.regionValue
      dictionary.checkReceived = updatedValues.checkedReceivedAnswer ? 1 : 0
      dictionary.checkSend = updatedValues.checkedSendAnswer ? 1 : 0
      dictionary.maxBudget = updatedValues.maxBudget
      dictionary.minBudget = updatedValues.minBudget
    }

    if (isBuyer) {
      dictionary = {
        ...dictionary,
        ...DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_BUYER
      }

      dictionary.provider = updatedValues.byProviderOption?.value || ''
    }

    if (!isBuyer && !isSeller) {
      dictionary = {
        ...dictionary,
        ...DIRECT_DEAL_SEARCH_FILTER_INITIAL_VALUES_BY_PUBLIC
      }

      dictionary.provider = updatedValues.byProviderOption?.value || ''
      dictionary.organizationTaxId = updatedValues.byOrganizationByRutOption?.value || ''
      dictionary.item = updatedValues.byItemOption?.value || ''
      dictionary.region = updatedValues.regionValue
      dictionary.maxBudget = updatedValues.maxBudget
      dictionary.minBudget = updatedValues.minBudget
    }

    updateQuery(query, dictionary)
    putCookie('search', query.toString())
    conditionalNavigate(query)
  }

  const updateAndSearch = changes => {
    setSearchValues(prev => {
      const next = {
        ...prev,
        ...changes
      }

      handleSearch(next)

      return next
    })
  }

  return {
    searchValues,
    updateAndSearch
  }
}
